import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { Steps } from 'hljd'
import store from './store'
import { observer } from 'mobx-react'
const Step = Steps.Step
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { id }
      }
    } = this.props
    store.id = id
  }

  render() {
    return (
      <HeaderView title="收银台">
        <div className={styles.box}>
          {/* {
                        status==0&&
                        <img src="https://qnm.hunliji.com/o_1chn9s55o1m8nifpq99d5k1pu49.png" />
                    }
                    {
                        status==1&&<img src="https://qnm.hunliji.com/o_1chn9s55o1rtj17um1ts3o8ltmba.png" />
                    } */}

          {/*<img src="https://qnm.hunliji.com/o_1chn9s55oa518l139skdcud4b.png" />*/}

          <div className={styles.steps}>
            <Steps labelPlacement={'vertical'}>
              <Step key={0} title="线下转账" />
              <Step key={1} title="完成审核" />
            </Steps>
          </div>
          <div className={styles.step_desc}>
            <span>通知财务部门给婚礼纪汇款</span>
            <span>婚礼纪会尽快审核，请您耐心等待</span>
          </div>

          <p className={styles.title}>收款信息</p>
          <div className={styles.text}>
            <p className={styles.p1}>收款银行卡号</p>
            <p style={{ fontSize: 20, fontWeight: 'bold' }}>
              1202 0262 0990 0201 857
            </p>
            <p className={styles.p1}>账户名</p>
            <p>杭州火烧云科技有限公司</p>
            <p className={styles.p1}>开户行</p>
            <p>中国工商银行杭州市高新支行</p>

            {/* <Button
                            type='primary'
                            style={{marginTop:35}}
                            onClick={store.havePay}
                            disabled={disabled}
                        >
                            已转账，通知平台审核
                        </Button> */}
          </div>
        </div>
      </HeaderView>
    )
  }
}
